import { LanguageSelector } from '@components/utility/selects';
import Typography from '@mui/material/Typography/Typography';
import { FormattedMessage } from 'react-intl';

const AuthenticationHeader = () => (
    <>
        <div className="flex justify-between items-start mb-10">
            <img src="/static/img/logo.png" alt="Victron Energy" className="h-11 w-min max-w-[230px]" />
            <LanguageSelector showFlag={false} />
        </div>
        <div className="mb-10">
            <Typography fontFamily="museo-sans" fontWeight={600} fontSize={40} lineHeight="110%" letterSpacing="-2%">
                Victron{' '}
                <Typography
                    component="span"
                    fontFamily="museo-sans"
                    fontWeight={600}
                    fontSize={40}
                    lineHeight="110%"
                    letterSpacing="-2%"
                    color="primary"
                >
                    Professional
                </Typography>
            </Typography>
            <Typography fontSize={16}>
                <FormattedMessage
                    id="auth.header.message"
                    defaultMessage="Welcome to the {brandName} Portal"
                    description="Welcome message shown at the top of login, sign up, and password reset pages. Used in: /auth/login, /auth/sign-up, /auth/forgot-password, /auth/set-new-password, /auth/link-account, /auth/migrate-account, /auth/password-confirmation, /auth/setup-2fa"
                    values={{
                        brandName: 'Victron Professional',
                    }}
                />
            </Typography>
        </div>
    </>
);

export { AuthenticationHeader };
